import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getForm } from 'api/taxi.backend';
import InputContainer from '../InputContainer';
import TextAreaAttribute from '../Fields/TextAreaAttribute';
import CopyToClipboardButton from '../CopyToClipboardButton';

// 1/15,000 chance  of hitting a double should  be safe enough
const getUniqueishId = () => new Array(6).fill(true).map(() => {
  const letterNum = Math.floor(Math.random() * 26);
  const idxWhereLettersStart = 97;
  return String.fromCharCode(idxWhereLettersStart + letterNum);
}).join('');

function EmbedSnippetGenerator({ setIsURLSaved, formID = '', onFieldUIStateChange, onFieldValueChange }) {
  const [htmlSnippet, setHTMLSnippet] = useState('');

  const createSnippet = () => `<div id="twou-form-${formID}-${getUniqueishId()}" class="self-mount-plugin" data-template-type="embed-inline" data-package-type="fetch" data-package-id="${formID}"></div><script src="https://prospect-form-plugin.2u.com/cask-latest/lead.form.plugin.js"></script>`;

  const handleSnippet = (isURLInDB, snippet) => {
    setIsURLSaved(isURLInDB);
    setHTMLSnippet(snippet);
  };

  const getSnippet = () => {
    getForm(formID)
      .then(({ thankYouURL }) => {
        thankYouURL ? handleSnippet(true, createSnippet()) : handleSnippet(false, '');
      });
  };

  return (
    <div>
      <CopyToClipboardButton className="btn btn-secondary p-0 m-2 position-absolute" textToCopy={htmlSnippet} />
      <InputContainer keyPath={['embedSnippet']}>
        <TextAreaAttribute
          style={{ height: '6rem' }}
          className="mt-4 w-100 mx-auto pl-5 text-white bg-dark"
          keyPath={['embedSnippet']}
          onFieldValueChange={onFieldValueChange}
          onFieldUIStateChange={onFieldUIStateChange}
          value={htmlSnippet || ''}
        />
      </InputContainer>

      <button
        type="button"
        className="btn btn-success mt-2 mx-auto d-block"
        onClick={getSnippet}
        id="generate-html-button"
      >
        Generate HTML Snippet
      </button>
    </div>
  );
}

EmbedSnippetGenerator.propTypes = {
  formID: PropTypes.string,
  setIsURLSaved: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
};

export default EmbedSnippetGenerator;
